import {
  CoverageBoard,
  type CoverageTileDef,
} from "../../../../shared/dashboard/CoverageBoard"
import { CUSTOMER_REQUESTS_BASE } from "../../../routes"
import type { DashboardWidgetProps } from "../customerWidgetRegistry"

const MC_BASE = "/material-compliance"

const TILES: CoverageTileDef<DashboardWidgetProps["stats"]>[] = [
  {
    labelKey: "MC_CSD_TILE_ANSWERING",
    subKey: "MC_CSD_TILE_ANSWERING_SUB",
    value: (s) => s.statusBuckets.answering,
    to: `${CUSTOMER_REQUESTS_BASE}?bucket=answering`,
  },
  {
    labelKey: "MC_CSD_TILE_WAITING",
    subKey: "MC_CSD_TILE_WAITING_SUB",
    value: (s) => s.statusBuckets.waitingOnYou,
    to: `${CUSTOMER_REQUESTS_BASE}?bucket=waiting`,
  },
  {
    labelKey: "MC_CSD_TILE_GAPS",
    subKey: "MC_CSD_TILE_GAPS_SUB",
    value: (s) => s.statusBuckets.gaps,
    to: `${CUSTOMER_REQUESTS_BASE}?bucket=gaps`,
  },
  {
    labelKey: "MC_CSD_TILE_OVERDUE",
    subKey: "MC_CSD_TILE_OVERDUE_SUB",
    value: (s) => s.statusBuckets.overdue,
    to: `${CUSTOMER_REQUESTS_BASE}?bucket=overdue`,
    critical: true,
  },
]

export function CoverageWidget({ stats, loadFailed }: DashboardWidgetProps) {
  return (
    <CoverageBoard
      stats={stats}
      primary={{
        value: (s) => s.products,
        labelKey: "MC_CSD_COV_PRODUCTS",
        popLabelKey: "MC_CSD_POP_PRODUCTS",
      }}
      secondary={{
        value: (s) => s.customers,
        labelKey: "MC_CSD_COV_CUSTOMERS",
        popLabelKey: "MC_CSD_POP_CUSTOMERS",
      }}
      popAbsoluteKey="MC_CSD_POP_ABSOLUTE"
      tilePopLabelKey="MC_CSD_POP_REQUESTS"
      tiles={TILES}
      emptyState={{
        // Fix B.2: zero products means the donut + customers stat are both
        // meaningless (0/0, 0%) — an onboarding hint is more useful than a
        // blank ring. The four pipeline tiles keep their own data and are
        // unaffected.
        // Not after a failed load: zero products is then the fallback, not the org.
        predicate: (s) => !loadFailed && s.products.total === 0,
        messageKey: "MC_CSD_COV_EMPTY",
        ctaKey: "MC_CSD_COV_EMPTY_CTA",
        ctaTo: `${MC_BASE}/master-data/products`,
      }}
    />
  )
}
